import React from 'react'
import {Modal, notification} from 'antd'
import {ObjectInspector} from 'react-inspector'
import {bulkSyncFulfillmentOrderByIds} from "../../../../../services/api/3dApi"

const syncDesignsAndGenerateByIds = async (ids) => {
    const payload = {
        ids
    }
    const {data: response} = await bulkSyncFulfillmentOrderByIds(payload)

    const {success, error, data} = response

    if (!success) {
        throw new Error(error)
    }

    return data
}

export default function (ids, onSuccess, onReset) {
    Modal.confirm({
        title: 'Xác nhận đồng bộ designs và tạo files in?',
        okText: 'Đồng bộ',
        cancelText: 'Hủy',
        onOk() {
            return syncDesignsAndGenerateByIds(ids).then(result => {
                notification.success({
                    message: 'Đồng bộ designs và tạo files in',
                    description: <ObjectInspector data={result}/>,
                    duration: 0,
                })
                onReset()
                onSuccess()
            }).catch(err => {
                notification.error({
                    message: 'ERROR',
                    description: err.message,
                    duration: 0,
                })
            })
        },
    })
}
